<template>
  <div class="xcard">
    <v-btn small class="ma-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>
    <h3 class="text-center my-0">Proyeccion por Sedes. 2026</h3>
    <hr />

    <v-row no-gutters>
      <v-col class="pr-1" cols="12" sm="2">
        <v-text-field v-model="input.fecha_inicio" type="date" label="Fecha inicio:" outlined dense hide-details />
      </v-col>

      <v-col class="pr-1" cols="12" sm="2">
        <v-text-field v-model="input.fecha_fin" type="date" label="Fecha fin:" outlined dense hide-details />
      </v-col>

      <v-col class="pr-1" cols="12" sm="3">
        <v-select
          v-model="input.universidad_id"
          :items="convenios"
          :loading="optionsloading"
          label="Universidad:"
          item-value="id"
          dense
          hide-details
          outlined></v-select>
      </v-col>
      <v-col class="pr-1" cols="12" sm="3">
        <v-select
          v-model="input.sede_id"
          :items="sedes"
          :loading="optionsloading"
          label="Sede:"
          item-value="id"
          dense
          hide-details
          outlined></v-select>
      </v-col>

      <v-col class="pl-0" cols="12" sm="2">
        <v-btn dense tile class="green darken-3" dark @click="precarga()"> Buscar </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="pl-4" cols="12" sm="6">
        <v-switch v-model="view_categorias" label="Por categorias" dense hide-details />
      </v-col>
    </v-row>

    <v-row no-gutters v-if="view_categorias && todasCategorias.length > 0">
      <v-col cols="12" class="pl-2 pt-1 d-flex flex-wrap align-center">
        <span class="caption grey--text text--darken-1 mr-2">Filtrar categorías:</span>
        <v-chip
          v-for="cat in todasCategorias"
          :key="cat"
          :color="filtrosCategorias.includes(cat) ? 'purple' : 'grey lighten-2'"
          :dark="filtrosCategorias.includes(cat)"
          small
          class="mr-1 mb-1"
          style="cursor: pointer"
          @click="toggleCategoria(cat)"
        >{{ cat }}</v-chip>
        <v-btn
          v-if="filtrosCategorias.length"
          x-small
          text
          color="grey darken-1"
          class="ml-2"
          @click="filtrosCategorias = []"
        >
          <v-icon x-small left>mdi-close</v-icon> Limpiar
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="meses_header.length > 0" class="mt-2">
      <v-col cols="12" :md="view_categorias && todasCategorias.length > 0 ? 6 : 12">
        <p class="text-center caption grey--text mb-1">Total proyectado por mes</p>
        <div style="position: relative; height: 240px;">
          <canvas ref="chartBar"></canvas>
        </div>
      </v-col>
      <v-col cols="12" md="6" v-if="view_categorias && todasCategorias.length > 0">
        <p class="text-center caption grey--text mb-1">Proyección por categoría y mes</p>
        <div style="position: relative; height: 240px;">
          <canvas ref="chartStacked"></canvas>
        </div>
      </v-col>
    </v-row>

    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="loading" />
    <p class="my-0 text-center red--text">{{ msg }}</p>

    <div v-if="!view_categorias">
      <div v-if="datos.length > 0" class="text-right">
        <v-btn dense tile color="purple" outlined dark class="mb-1 mr-1" small @click="tableToExcel('table1')">
          <v-icon left>mdi-download</v-icon> Descargar excel
        </v-btn>
        <v-btn dense tile color="red darken-2" outlined dark class="mb-1" small @click="descargarPDF('table1')" :loading="exportandoPDF">
          <v-icon left>mdi-file-pdf-box</v-icon> Descargar PDF
        </v-btn>
      </div>
      <div class="table-responsive">
        <table class="xtable table-hover" ref="table1">
          <thead class="text-center green darken-4 white--text">
            <tr class="white--text">
              <th class="text-center fixedheader" rowspan="2">ID</th>
              <th class="text-center fixedheader" rowspan="2">Programas</th>
              <th :colspan="meses_header.length">Meses</th>
              <th rowspan="2">TOTAL</th>
            </tr>
            <tr class="white--text">
              <th v-for="m in meses_header" :key="m.nombre">{{ m.nombre }}</th>
            </tr>
          </thead>

          <tbody class="text-right">
            <tr v-for="(d, indice) in datos" :key="indice" class="cuerpo">
              <td class="text-center">{{ d.programa.programa_id }}</td>
              <td class="text-left"><b>{{indice+1}}.-</b> [{{ d.programa.codigo }}] {{ d.programa.nombre }}</td>
              <td v-for="(m, mi) in d.meses" :key="mi" class="text-right">{{ parsecomas(m.total ?? 0) }}</td>
              <td class="text-right font-weight-bold">{{ parsecomas(totalPorPrograma(d)) }}</td>
            </tr>
            <tr>
              <td colspan="2" rowspan="2" class="xrowtotal">TOTAL</td>
            </tr>
            <tr>
              <td v-for="m in meses_header" :key="m.nombre" class="xrowtotal">{{ parsecomas(m.xtotal_mes) }}</td>
              <td class="xrowtotal font-weight-black">{{ parsecomas(totalGeneral) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else>
      <div v-if="datos.length > 0" class="text-right">
        <v-btn dense tile color="purple" outlined dark class="mb-1 mr-1" small @click="tableToExcel('table2')">
          <v-icon left>mdi-download</v-icon> Descargar excel
        </v-btn>
        <v-btn dense tile color="red darken-2" outlined dark class="mb-1" small @click="descargarPDF('table2')" :loading="exportandoPDF">
          <v-icon left>mdi-file-pdf-box</v-icon> Descargar PDF
        </v-btn>
      </div>
      <div class="table-responsive">
        <table class="xtable table-hover" ref="table2">
          <thead class="text-center green darken-4 white--text">
            <tr class="white--text">
              <th class="text-center fixedheader" rowspan="2">ID</th>
              <th class="text-center fixedheader" rowspan="2" colspan="2">Programas</th>
              <th :colspan="meses_header.length">Meses</th>
              <th rowspan="2">TOTAL</th>
            </tr>
            <tr class="white--text">
              <th v-for="m in meses_header" :key="m.nombre">{{ m.nombre }}</th>
            </tr>
          </thead>

          <tbody class="text-right">
            <tr v-for="(fila, fi) in filasCategoria" :key="fi" class="cuerpo">
              <template v-if="fila.tipo === 'prog'">
                <td :rowspan="fila.rowspan" class="text-center">{{ fila.d.programa.programa_id }}</td>
                <td :rowspan="fila.rowspan" class="text-left">
                  <b>{{fila.indice+1}}.-</b> [{{ fila.d.programa.codigo }}] {{ fila.d.programa.nombre }}
                </td>
              </template>
              <template v-if="fila.tipo === 'cat'">
                <td style="width: 150px !important">{{ fila.c.nombre }}</td>
                <td v-for="(m, l) in fila.d.meses" :key="l" class="text-right">
                  {{
                    parsecomas(
                      (fila.d.meses[l].categorias.find((x) => x.nombre == fila.c.nombre) || {}).monto ?? 0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold">{{ parsecomas(totalPorCategoria(fila.d, fila.c.nombre)) }}</td>
              </template>
            </tr>
            <tr>
              <td colspan="3" rowspan="2" class="xrowtotal"></td>
            </tr>
            <tr>
              <td v-for="m in totalesMesFiltrados" :key="m.nombre" class="xrowtotal">{{ parsecomas(m.total) }}</td>
              <td class="xrowtotal font-weight-black">{{ parsecomas(totalGeneralFiltrado) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <toexcel ref="toexcel" />
  </div>
</template>

<style>
  @import url('./stilotablas.css');
</style>

<script>
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import toexcel from './toexcel';
  import Chart from 'chart.js';

  const COLORES_GRAFICO = [
    'rgba(103, 58, 183, 0.8)',
    'rgba(33, 150, 243, 0.8)',
    'rgba(76, 175, 80, 0.8)',
    'rgba(255, 152, 0, 0.8)',
    'rgba(233, 30, 99, 0.8)',
    'rgba(0, 188, 212, 0.8)',
    'rgba(255, 87, 34, 0.8)',
    'rgba(63, 81, 181, 0.8)',
  ];
  export default {
    data() {
      return {
        datos: [],
        optionsloading: false,
        view_categorias: false,
        filtrosCategorias: [],
        chartInstanceBar: null,
        chartInstanceStacked: null,
        exportandoPDF: false,
        meses_header: [],
        convenios: [],
        sedes: [],
        msg: '',
        loading: false,
        input: {
          fecha_inicio: null,
          fecha_fin: null,
          universidad_id: null,
          sede_id: null,
        },
      };
    },
    components: { toexcel },
    watch: {
      meses_header() {
        this.$nextTick(() => {
          this.renderChartBar();
          if (this.view_categorias) this.renderChartStacked();
        });
      },
      view_categorias() {
        this.$nextTick(() => {
          this.renderChartBar();
          if (this.view_categorias) this.renderChartStacked();
        });
      },
      filtrosCategorias() {
        if (this.view_categorias) this.$nextTick(() => this.renderChartStacked());
      },
    },
    computed: {
      todasCategorias() {
        const cats = new Set();
        this.datos.forEach((d) => {
          d.meses.forEach((m) => {
            m.categorias.forEach((c) => cats.add(c.nombre));
          });
        });
        return Array.from(cats).sort();
      },
      totalGeneral() {
        return this.meses_header.reduce((sum, m) => sum + (m.xtotal_mes || 0), 0);
      },
      totalesMesFiltrados() {
        if (!this.filtrosCategorias.length) {
          return this.meses_header.map((m) => ({ nombre: m.nombre, total: m.xtotal_mes || 0 }));
        }
        return this.meses_header.map((mes) => ({
          nombre: mes.nombre,
          total: this.datos.reduce((sum, d) => {
            const m = d.meses.find((mm) => mm.nombre === mes.nombre);
            if (!m) return sum;
            return sum + m.categorias
              .filter((c) => this.filtrosCategorias.includes(c.nombre))
              .reduce((s, c) => s + (c.monto || 0), 0);
          }, 0),
        }));
      },
      totalGeneralFiltrado() {
        return this.totalesMesFiltrados.reduce((sum, m) => sum + m.total, 0);
      },
      datosGraficoCategoria() {
        const labels = this.meses_header.map((m) => m.nombre);
        const cats = this.filtrosCategorias.length ? this.filtrosCategorias : Array.from(this.todasCategorias);
        const datasets = cats.map((catNombre, i) => {
          const data = this.meses_header.map((mes) =>
            this.datos.reduce((sum, d) => {
              const m = d.meses.find((mm) => mm.nombre === mes.nombre);
              if (!m) return sum;
              const cat = m.categorias.find((c) => c.nombre === catNombre);
              return sum + (cat ? cat.monto || 0 : 0);
            }, 0)
          );
          return {
            label: catNombre,
            data,
            backgroundColor: COLORES_GRAFICO[i % COLORES_GRAFICO.length],
            borderColor: COLORES_GRAFICO[i % COLORES_GRAFICO.length].replace('0.8', '1'),
            borderWidth: 1,
          };
        });
        return { labels, datasets };
      },
      filasCategoria() {
        const filas = [];
        this.datos.forEach((d, indice) => {
          const categoriasUnicas = [];
          d.meses.forEach((m) => {
            m.categorias.forEach((c) => {
              if (!categoriasUnicas.find((x) => x.nombre === c.nombre)) {
                categoriasUnicas.push(c);
              }
            });
          });
          const catsFiltradas = this.filtrosCategorias.length
            ? categoriasUnicas.filter((c) => this.filtrosCategorias.includes(c.nombre))
            : categoriasUnicas;
          if (catsFiltradas.length === 0) return;
          filas.push({ tipo: 'prog', d, indice, rowspan: catsFiltradas.length + 1 });
          catsFiltradas.forEach((c) => {
            filas.push({ tipo: 'cat', d, indice, c });
          });
        });
        return filas;
      },
    },
    methods: {
      renderChartBar() {
        if (this.chartInstanceBar) {
          this.chartInstanceBar.destroy();
          this.chartInstanceBar = null;
        }
        const ctx = this.$refs.chartBar;
        if (!ctx || !this.meses_header.length) return;
        const fmt = (v) => Number(v).toLocaleString('es-BO', { maximumFractionDigits: 0 });
        this.chartInstanceBar = new Chart(ctx.getContext('2d'), {
          type: 'bar',
          data: {
            labels: this.meses_header.map((m) => m.nombre),
            datasets: [{
              label: 'Total proyectado (Bs)',
              data: this.meses_header.map((m) => m.xtotal_mes || 0),
              backgroundColor: 'rgba(56, 142, 60, 0.75)',
              borderColor: '#2e7d32',
              borderWidth: 1,
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            scales: {
              xAxes: [{ gridLines: { display: false } }],
              yAxes: [{
                ticks: { beginAtZero: true, callback: fmt },
              }],
            },
            tooltips: {
              callbacks: {
                label: (item) => ` Bs ${fmt(item.yLabel)}`,
              },
            },
          },
        });
      },
      renderChartStacked() {
        if (this.chartInstanceStacked) {
          this.chartInstanceStacked.destroy();
          this.chartInstanceStacked = null;
        }
        const ctx = this.$refs.chartStacked;
        if (!ctx || !this.meses_header.length) return;
        const fmt = (v) => Number(v).toLocaleString('es-BO', { maximumFractionDigits: 0 });
        const d = this.datosGraficoCategoria;
        this.chartInstanceStacked = new Chart(ctx.getContext('2d'), {
          type: 'bar',
          data: { labels: d.labels, datasets: d.datasets },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { position: 'bottom', labels: { boxWidth: 12 } },
            scales: {
              xAxes: [{ stacked: true, gridLines: { display: false } }],
              yAxes: [{
                stacked: true,
                ticks: { beginAtZero: true, callback: fmt },
              }],
            },
            tooltips: {
              mode: 'index',
              callbacks: {
                label: (item, data) => ` ${data.datasets[item.datasetIndex].label}: Bs ${fmt(item.yLabel)}`,
              },
            },
          },
        });
      },
      descargarPDF(refName) {
        const el = this.$refs[refName];
        if (!el) return;
        this.exportandoPDF = true;
        window.html2pdf()
          .set({
            margin: [0.3, 0.3, 0.3, 0.3],
            filename: 'proyeccion-sedes.pdf',
            image: { type: 'jpeg', quality: 0.95 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'in', format: 'a3', orientation: 'landscape' },
          })
          .from(el)
          .save()
          .then(() => { this.exportandoPDF = false; })
          .catch((e) => {
            window.console.error(e);
            this.exportandoPDF = false;
          });
      },
      tableToExcel(table) {
        if (!table.nodeType) table = this.$refs[table];
        this.$refs.toexcel.tableToExcel(table, 'proy-sedes.xls');
      },
      totalPorPrograma(d) {
        return d.meses.reduce((sum, m) => sum + (m.total || 0), 0);
      },
      totalPorCategoria(d, nombreCategoria) {
        return d.meses.reduce((sum, m) => {
          const cat = m.categorias.find((c) => c.nombre === nombreCategoria);
          return sum + (cat ? cat.monto || 0 : 0);
        }, 0);
      },
      toggleCategoria(cat) {
        const idx = this.filtrosCategorias.indexOf(cat);
        if (idx === -1) {
          this.filtrosCategorias = [...this.filtrosCategorias, cat];
        } else {
          this.filtrosCategorias = this.filtrosCategorias.filter((c) => c !== cat);
        }
      },
      rowspanFiltrado(d) {
        let categoriasUnicas = [];
        d.meses.forEach((m) => {
          m.categorias.forEach((c) => {
            if (!categoriasUnicas.find((x) => x.nombre == c.nombre)) {
              categoriasUnicas.push(c);
            }
          });
        });
        if (this.filtrosCategorias.length) {
          categoriasUnicas = categoriasUnicas.filter((c) => this.filtrosCategorias.includes(c.nombre));
        }
        return categoriasUnicas.length + 1;
      },
      parsecomas(str) {
        if (str == null) return '';
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      getrowspan(d) {
        /* let categorias = 0;
        let max_categorias = 0;
        d.meses.forEach((x) => {
          categorias += x.categorias.length;
          max_categorias = x.categorias.length;
        });
        categorias += d.meses.length;
        d.xrowspan2 = max_categorias + 1;
        d.xrowspan = categorias + 1; */
        let categoriasUnicas = [];

        d.meses.forEach((m) => {
          m.categorias.forEach((c) => {
            if (!categoriasUnicas.find((x) => x.nombre == c.nombre)) {
              categoriasUnicas.push(c);
            }
          });
        });

        d.xrowspan2 = categoriasUnicas.length + 1;
      },
      addCategoriasFaltantes(data, xcates) {
        let vue = this;
        data.meses.forEach((m) => {
          xcates.forEach((xc) => {
            let existe = m.categorias.find((c) => c.nombre == xc.nombre);
            if (!existe) {
              let copia = JSON.parse(JSON.stringify(xc));
              copia.monto = null;
              copia.nombre += '';
              m.categorias.push(copia);
            }
          });
        });
        vue.getrowspan(data);
      },
      addMesesFaltantes(data, xcates) {
        xcates.forEach((xc) => {
          let existe = data.meses.find((c) => c.nombre == xc.nombre);
          if (!existe) {
            let copia = JSON.parse(JSON.stringify(xc));
            copia.numero = xc.numero;
            copia.nombre = xc.nombre;
            copia.categorias = [];
            data.meses.push(copia);
          }
        });
      },
      async getConveniosUniversidades() {
        this.optionsloading = true;
        let q =
          'query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} getSedes {   id   nombre } }';
        const sql = gql`
          ${q}
        `;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          let conves = data.getInstituciones;
          let units = data.getSedes;
          conves.map((x) => {
            x.text = `[${x.abreviatura}] ${x.nombre}`;
          });
          units.map((x) => {
            x.text = `[${x.id}] ${x.nombre}`;
          });
          conves = conves.filter((x) => {
            return x.convenio;
          });
          conves.unshift({ id: 0, text: '[0] BUSCAR DE TODOS' });
          this.convenios = conves;
          this.sedes = units;
          this.optionsloading = false;
        });
      },
      precarga() {
        this.msg = '';
        if (!this.input.fecha_inicio) this.msg = 'ingrese fecha de inicio';
        if (!this.input.fecha_fin) this.msg = 'ingrese fecha fin';
        if (this.input.universidad_id == null) this.msg = 'ingrese universidad';
        if (!this.input.sede_id) this.msg = 'ingrese sede';
        if (this.msg) return;
        this.cargarfromserver();
      },
      cargarfromserver() {
        this.loading = true;
        this.datos = [];
        let vue = this;
        let params = `api/v1/esam/proyeccion/sedes?sede_id=${this.input.sede_id}&fecha_inicio=${this.input.fecha_inicio}&fecha_fin=${this.input.fecha_fin}&universidad_id=${this.input.universidad_id}`;
        const url = `${process.env.VUE_APP_API_REST}/${params}`;
        xaxios
          .get(url)
          .then(({ data }) => {
            window.console.log(data.data);
            vue.defecto(data.data);
            vue.loading = false;
          })
          .catch((e) => {
            window.console.log(e);
            vue.msg = e;
            vue.loading = false;
          });
      },
      parseJson(data) {
        let existentes = [];
        data.forEach((d) => {
          d.meses.forEach((m) => {
            let ex = existentes.find((xm) => xm.nombre == m.nombre);
            let copia = JSON.parse(JSON.stringify(m));
            copia.xtotal_mes = m.total;
            if (!ex) existentes.push(copia);
            else ex.xtotal_mes += m.total;
          });
        });
        existentes.sort((a, b) => {
          return a.numero - b.numero;
        });
        data.forEach((d) => {
          let xm = [];
          existentes.forEach((m) => {
            let existemes = d.meses.find((xm) => xm.nombre == m.nombre);
            if (!existemes) xm.push({ nombre: m, numero: -1, categorias: [], conceptos: [] });
            else xm.push(JSON.parse(JSON.stringify(existemes)));
          });
          d.meses = xm;
        });
        return existentes;
      },
      defecto(data) {
        let vue = this;
        let xmeses = this.parseJson(data);
        let xindex = 1;

        data.forEach((x) => {
          x.meses.forEach((m) => {
            m.categorias.sort((a, b) => {
              return a.nombre.localeCompare(b.nombre);
            });
          });
        });

        data.forEach((x) => {
          x.xindex = xindex++;
          vue.getrowspan(x);
          // let size_categorias_min = 0;
          // let size_categorias_max = 0;
          let xcategorias = [];

          /* x.meses.forEach((m, j) => { 
            m.xindex = xindex++;
            if (j == 0) {
              size_categorias_min = m.categorias.length;
              size_categorias_max = m.categorias.length;
              xcategorias = JSON.parse(JSON.stringify(m.categorias));
            } else {
              let sz = m.categorias.length;
              if (sz < size_categorias_min) size_categorias_min = sz;
              if (sz > size_categorias_max) {
                size_categorias_max = sz;
                xcategorias = JSON.parse(JSON.stringify(m.categorias));
              }
            }
            m.categorias.forEach((c) => {
              c.xindex = xindex++;
            });
          }); */

          x.meses.forEach((m) => {
            m.categorias.forEach((c) => {
              let existe = xcategorias.find((xc) => xc.nombre == c.nombre);
              if (!existe) {
                xcategorias.push(JSON.parse(JSON.stringify(c)));
              }
            });
          });

          //if (size_categorias_max - size_categorias_min != 0) {
            this.addCategoriasFaltantes(x, xcategorias);
          //}
        });

        window.console.log(JSON.stringify(data, null, 2));
        // xmeses.sort((a, b) => {
        //   return a.numero - b.numero;
        // });
        this.meses_header = xmeses;
        this.datos = data;
      },
    },
    mounted() {
      this.getConveniosUniversidades();
    },
    beforeDestroy() {
      if (this.chartInstanceBar) this.chartInstanceBar.destroy();
      if (this.chartInstanceStacked) this.chartInstanceStacked.destroy();
    },
  };
</script>
